var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-tasklists" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c("masteradmin-sidebar-menu"),
          _vm._v(" "),
          _c("div", { staticClass: "content-wrapper", attrs: { id: "top" } }, [
            _c("div", { staticClass: "container-wrapper center" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showOverlay,
                      expression: "showOverlay"
                    }
                  ],
                  staticClass: "modal-custom"
                },
                [_vm._m(0)]
              ),
              _vm._v(" "),
              _c("div", [
                _vm._m(1),
                _vm._v(" "),
                _vm.assessment_section_lists.length > 0 && _vm.loading == false
                  ? _c(
                      "div",
                      { staticClass: "col-lg-2 float-left override-padding" },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-white col-12 override-padding",
                            staticStyle: {
                              "margin-top": "2px",
                              height: "30px",
                              "border-radius": "10px",
                              "font-weight": "bold"
                            },
                            on: {
                              click: function($event) {
                                return _vm.scrollTo("Bottom")
                              }
                            }
                          },
                          [
                            _vm._v("Jump to Bottom "),
                            _c("i", {
                              staticClass: "cursor-pointer fa fa-angle-down",
                              staticStyle: {
                                "font-size": "21px",
                                color: "#333",
                                "padding-left": "5px",
                                "vertical-align": "bottom"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticStyle: { clear: "both" } })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "heading-seperator" }),
              _vm._v(" "),
              _c("div", { staticClass: "margin-bottom-10" }),
              _vm._v(" "),
              _c(
                "div",
                {},
                [
                  _c(
                    "b-navbar",
                    {
                      attrs: {
                        toggleable: "lg",
                        type: "light",
                        variant: "light"
                      }
                    },
                    [
                      _c("b-navbar-brand", { attrs: { href: "#" } }, [
                        _vm._v("Filter/Search")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-navbar-toggle",
                        { attrs: { target: "nav-collapse" } },
                        [_c("i", { staticClass: "fa fa-chevron-down\t" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-collapse",
                        { attrs: { id: "nav-collapse", "is-nav": "" } },
                        [
                          _c("div", { staticClass: "search-wrapper col-12" }, [
                            _c(
                              "div",
                              { staticClass: "row col-12 override-padding" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-lg-3 col-md-12 col-12 padding-lr-5",
                                    staticStyle: {
                                      "padding-left": "0",
                                      "padding-right": "0"
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "input-text",
                                      attrs: {
                                        type: "text",
                                        placeholder:
                                          "Search by Assessment Section Title",
                                        maxlength: "255"
                                      },
                                      on: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.filterAssessmentSectionitems()
                                        }
                                      },
                                      model: {
                                        value: _vm.search_keyword,
                                        callback: function($$v) {
                                          _vm.search_keyword = $$v
                                        },
                                        expression: "search_keyword"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-lg-2 col-md-12 col-12 padding-lr-5",
                                    staticStyle: { "padding-right": "0" }
                                  },
                                  [
                                    _c("b-form-select", {
                                      staticClass: "input-text",
                                      attrs: { options: _vm.scale_options },
                                      on: {
                                        change: function($event) {
                                          return _vm.filterAssessmentSectionitems()
                                        }
                                      },
                                      model: {
                                        value: _vm.search_scale,
                                        callback: function($$v) {
                                          _vm.search_scale = $$v
                                        },
                                        expression: "search_scale"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-lg-2 col-md-12 col-12 padding-lr-5",
                                    staticStyle: { "margin-top": "2px" }
                                  },
                                  [
                                    _c("date-picker", {
                                      attrs: {
                                        format: "MM/DD/YYYY",
                                        placeholder: "Date",
                                        clearable: false,
                                        "input-class":
                                          "col-md-12 input-height-30 padding-lr-5"
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "icon-calendar",
                                          fn: function() {
                                            return [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-calendar red-color",
                                                attrs: { "aria-hidden": "true" }
                                              })
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ]),
                                      model: {
                                        value: _vm.search_date,
                                        callback: function($$v) {
                                          _vm.search_date = $$v
                                        },
                                        expression: "search_date"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-lg-1 col-md-12 col-12 padding-lr-5",
                                    staticStyle: {
                                      "padding-left": "0",
                                      "padding-right": "0"
                                    }
                                  },
                                  [
                                    _c("b-form-select", {
                                      staticClass: "input-text",
                                      attrs: { options: _vm.status_options },
                                      on: {
                                        change: function($event) {
                                          return _vm.filterAssessmentSectionitems()
                                        }
                                      },
                                      model: {
                                        value: _vm.search_status,
                                        callback: function($$v) {
                                          _vm.search_status = $$v
                                        },
                                        expression: "search_status"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-lg-2 col-md-12 col-12 padding-lr-5"
                                  },
                                  [
                                    _c("b-form-select", {
                                      staticClass: "input-text",
                                      attrs: { options: _vm.user_options },
                                      on: {
                                        change: function($event) {
                                          return _vm.filterAssessmentSectionitems()
                                        }
                                      },
                                      model: {
                                        value: _vm.search_user,
                                        callback: function($$v) {
                                          _vm.search_user = $$v
                                        },
                                        expression: "search_user"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-lg-1 col-md-4 col-4 padding-lr-5"
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-red col-12 padding-lr-5",
                                        staticStyle: {
                                          height: "32px",
                                          "border-radius": "10px",
                                          "margin-top": "2px",
                                          "font-weight": "bold"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.filterAssessmentSectionitems()
                                          }
                                        }
                                      },
                                      [_vm._v("Search")]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-lg-1 col-md-4 col-4 padding-lr-5"
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-white col-12 override-padding",
                                        staticStyle: {
                                          "margin-top": "2px",
                                          height: "32px",
                                          "border-radius": "10px",
                                          "font-weight": "bold"
                                        },
                                        on: {
                                          click: function($event) {
                                            ;(_vm.isModalVisible = true),
                                              _vm.verrors.clear()
                                          }
                                        }
                                      },
                                      [_vm._v("New Section")]
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "margin-bottom-10" }),
              _vm._v(" "),
              _vm.rows > 1
                ? _c(
                    "div",
                    {
                      staticClass:
                        "overflow-auto float-right pagination-wrapper",
                      staticStyle: { margin: "0" }
                    },
                    [
                      _c("b-pagination", {
                        attrs: {
                          "total-rows": _vm.rows,
                          "per-page": _vm.perPage,
                          "first-text": "First",
                          "prev-text": "Prev",
                          "next-text": "Next",
                          "last-text": "Last",
                          "hide-goto-end-buttons": true
                        },
                        on: {
                          input: function($event) {
                            return _vm.showTasklistofPaginated()
                          }
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticStyle: { clear: "both" } }),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.verrors.has("sections"),
                        expression: "verrors.has('sections')"
                      }
                    ],
                    staticClass: "validate-warning-msg"
                  },
                  [_vm._v(_vm._s(_vm.verrors.first("sections")))]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "row tasks_heading_row" }, [
                  _c(
                    "div",
                    {
                      staticClass: "bold cursor-pointer col-3",
                      on: {
                        click: function($event) {
                          return _vm.sortMethod("title")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                   Assessment Section Title\n                   "
                      ),
                      _vm.sortField == "title" && _vm.sortBy == "ASC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-asc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sortField == "title" && _vm.sortBy == "DESC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-desc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "bold cursor-pointer col-2 override-padding",
                      on: {
                        click: function($event) {
                          return _vm.sortMethod("scale")
                        }
                      }
                    },
                    [
                      _vm._v("\n                   Scale\n                   "),
                      _vm.sortField == "scale" && _vm.sortBy == "ASC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-asc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sortField == "scale" && _vm.sortBy == "DESC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-desc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "bold col-1 override-padding text-align-center"
                    },
                    [
                      _vm._v(
                        "\n                   # of S/Q's\n                   \n                 "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "bold cursor-pointer col-1 override-padding",
                      on: {
                        click: function($event) {
                          return _vm.sortMethod("createdAt")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                   Date Created\n                   "
                      ),
                      _vm.sortField == "createdAt" && _vm.sortBy == "ASC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-asc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sortField == "createdAt" && _vm.sortBy == "DESC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-desc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "bold cursor-pointer col-1 override-padding",
                      on: {
                        click: function($event) {
                          return _vm.sortMethod("updatedBy")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                   Last Updated By\n                   "
                      ),
                      _vm.sortField == "updatedBy" && _vm.sortBy == "ASC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-asc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sortField == "updatedBy" && _vm.sortBy == "DESC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-desc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "bold cursor-pointer col-1 override-padding",
                      on: {
                        click: function($event) {
                          return _vm.sortMethod("updatedAt")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                   Last Updated\n                   "
                      ),
                      _vm.sortField == "updatedAt" && _vm.sortBy == "ASC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-asc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sortField == "updatedAt" && _vm.sortBy == "DESC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-desc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "bold cursor-pointer col-1 override-padding",
                      on: {
                        click: function($event) {
                          return _vm.sortMethod("status")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                   Status\n                   "
                      ),
                      _vm.sortField == "status" && _vm.sortBy == "ASC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-asc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sortField == "status" && _vm.sortBy == "DESC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-desc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "bold cursor-pointer col-1 override-padding",
                      on: {
                        click: function($event) {
                          return _vm.sortMethod("createdBy")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                   Created By\n                   "
                      ),
                      _vm.sortField == "createdBy" && _vm.sortBy == "ASC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-asc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.sortField == "createdBy" && _vm.sortBy == "DESC"
                        ? _c("i", {
                            staticClass: "fa fa-sort-desc",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "bold col-1 override-padding text-align-right",
                      staticStyle: { "padding-right": "20px" }
                    },
                    [_vm._v("\n                   Options\n                 ")]
                  )
                ]),
                _vm._v(" "),
                _vm.assessment_section_lists.length == 0 && _vm.loading == false
                  ? _c(
                      "div",
                      {
                        staticClass: "col-12 text-align-center",
                        staticStyle: {
                          "background-color": "#FFF",
                          "min-height": "480px",
                          "padding-top": "180px"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 text-align-center no-assessment-text"
                          },
                          [_vm._v("No assessment sections created")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-white col-2 override-padding",
                            staticStyle: {
                              "margin-top": "10px",
                              height: "35px",
                              "border-radius": "10px",
                              "font-weight": "bold"
                            },
                            on: {
                              click: function($event) {
                                ;(_vm.isModalVisible = true),
                                  _vm.verrors.clear()
                              }
                            }
                          },
                          [_vm._v("New Section")]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass: "loading_show"
                  },
                  [_c("div", { staticClass: "spinner-border text-danger" })]
                ),
                _vm._v(" "),
                _vm.assessment_section_lists.length > 0
                  ? _c(
                      "div",
                      { staticClass: "card-text" },
                      [
                        _vm._l(_vm.assessment_section_lists, function(
                          list,
                          index
                        ) {
                          return _c("div", { staticClass: "tasklists-row" }, [
                            _c(
                              "div",
                              {
                                staticClass: "row tasklist-item",
                                staticStyle: { margin: "0" }
                              },
                              [
                                _c("div", { staticClass: "col-3" }, [
                                  _vm.checkboxVisible == 0
                                    ? _c("span", [
                                        list.status == "PUBLISH" &&
                                        _vm.assessment_id > 0 &&
                                        _vm.isEditModalVisible == false &&
                                        _vm.isModalVisible == false
                                          ? _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.sections_selected,
                                                  expression:
                                                    "sections_selected"
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate"
                                                }
                                              ],
                                              attrs: {
                                                type: "checkbox",
                                                name: "sections",
                                                id: list.id,
                                                "data-vv-rules": "required",
                                                "data-vv-as": "Sections"
                                              },
                                              domProps: {
                                                value: list.id,
                                                checked: Array.isArray(
                                                  _vm.sections_selected
                                                )
                                                  ? _vm._i(
                                                      _vm.sections_selected,
                                                      list.id
                                                    ) > -1
                                                  : _vm.sections_selected
                                              },
                                              on: {
                                                change: function($event) {
                                                  var $$a =
                                                      _vm.sections_selected,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = list.id,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.sections_selected = $$a.concat(
                                                          [$$v]
                                                        ))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.sections_selected = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.sections_selected = $$c
                                                  }
                                                }
                                              }
                                            })
                                          : _vm._e()
                                      ])
                                    : _c("span", [
                                        list.status == "PUBLISH" &&
                                        _vm.assessment_id > 0
                                          ? _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.sections_selected,
                                                  expression:
                                                    "sections_selected"
                                                }
                                              ],
                                              attrs: {
                                                type: "checkbox",
                                                name: "sections",
                                                id: list.id
                                              },
                                              domProps: {
                                                value: list.id,
                                                checked: Array.isArray(
                                                  _vm.sections_selected
                                                )
                                                  ? _vm._i(
                                                      _vm.sections_selected,
                                                      list.id
                                                    ) > -1
                                                  : _vm.sections_selected
                                              },
                                              on: {
                                                change: function($event) {
                                                  var $$a =
                                                      _vm.sections_selected,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = list.id,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.sections_selected = $$a.concat(
                                                          [$$v]
                                                        ))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.sections_selected = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.sections_selected = $$c
                                                  }
                                                }
                                              }
                                            })
                                          : _vm._e()
                                      ]),
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(list.title) +
                                      "\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-2 override-padding " },
                                  [_vm._v(_vm._s(_vm.getScale(list.scale)))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-1 override-padding text-align-center"
                                  },
                                  [_vm._v(_vm._s(list.statement_count))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-1 override-padding" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.FollowDate(list.createdAt))
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-1 override-padding" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.truncate(list.updated_by))
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-1 override-padding" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.FollowDate(list.updatedAt))
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-1 override-padding" },
                                  [_vm._v(_vm._s(_vm.getStatus(list.status)))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-1 override-padding" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.truncate(list.created_by))
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-1 override-padding" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "dropdown",
                                        attrs: {
                                          id: "dropdown-container" + index
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.toggleDropdown(
                                              "actionDropdown" + index + ""
                                            )
                                          }
                                        }
                                      },
                                      [
                                        list.status != "DEACTIVATED"
                                          ? _c(
                                              "ul",
                                              {
                                                staticClass:
                                                  "dropbtn icons btn-right showLeft",
                                                attrs: {
                                                  id: "dotted-menu" + index
                                                }
                                              },
                                              [
                                                _c("li"),
                                                _vm._v(" "),
                                                _c("li"),
                                                _vm._v(" "),
                                                _c("li")
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "dropdown-content",
                                            attrs: {
                                              id: "actionDropdown" + index
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "action-dd-menu",
                                                attrs: { href: "" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.editSectionMethod(
                                                      list.id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "cursor-pointer fa fa-edit  spacer-icon"
                                                }),
                                                _vm._v("Edit")
                                              ]
                                            ),
                                            _vm._v(" "),
                                            list.status == "DRAFT"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "action-dd-menu",
                                                    attrs: { href: "" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.updateSectionStatus(
                                                          list.id,
                                                          "PUBLISH"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "cursor-pointer fa fa-upload spacer-icon"
                                                    }),
                                                    _vm._v("Publish")
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            list.status == "DRAFT"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "action-dd-menu",
                                                    attrs: { href: "" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.deleteSectionConfirm(
                                                          list.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "cursor-pointer fa fa-times spacer-icon"
                                                    }),
                                                    _vm._v("Remove")
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            list.status == "PUBLISH"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "action-dd-menu",
                                                    attrs: { href: "" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.deactivateSectionConfirm(
                                                          list.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "cursor-pointer fa fa-eye-slash spacer-icon"
                                                    }),
                                                    _vm._v("Deactivate")
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._m(2, true)
                          ])
                        }),
                        _vm._v(" "),
                        _vm.rows > 25
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "overflow-auto float-right pagination-wrapper",
                                staticStyle: { "margin-bottom": "0" }
                              },
                              [
                                _c("b-pagination", {
                                  attrs: {
                                    "total-rows": _vm.rows,
                                    "per-page": _vm.perPage,
                                    "first-text": "First",
                                    "prev-text": "Prev",
                                    "next-text": "Next",
                                    "last-text": "Last",
                                    "hide-goto-end-buttons": true
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.showTasklistofPaginated()
                                    }
                                  },
                                  model: {
                                    value: _vm.currentPage,
                                    callback: function($$v) {
                                      _vm.currentPage = $$v
                                    },
                                    expression: "currentPage"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticStyle: { clear: "both" } })
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.assessment_section_lists.length > 0 && _vm.loading == false
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-top": "20px",
                          "margin-bottom": "30px"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "col-lg-10 float-left override-padding"
                          },
                          [_vm._v("\n             \n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-lg-2 float-left override-padding"
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-white col-12 override-padding",
                                staticStyle: {
                                  "margin-top": "2px",
                                  height: "30px",
                                  "border-radius": "10px",
                                  "font-weight": "bold"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.scrollTo("Top")
                                  }
                                }
                              },
                              [
                                _vm._v("Jump to Top "),
                                _c("i", {
                                  staticClass: "cursor-pointer fa fa-angle-up",
                                  staticStyle: {
                                    "font-size": "21px",
                                    color: "#333",
                                    "padding-left": "5px",
                                    "vertical-align": "bottom"
                                  }
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticStyle: { clear: "both" } })
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.assessment_id > 0
                ? _c(
                    "div",
                    {
                      staticClass: "col-12 override-padding text-align-left",
                      staticStyle: {
                        "margin-top": "10px",
                        "margin-bottom": "25px"
                      }
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-red col-2 padding-lr-5",
                          staticStyle: {
                            "line-height": "25px",
                            "border-radius": "10px"
                          },
                          on: {
                            click: function($event) {
                              return _vm.onSubmit()
                            }
                          }
                        },
                        [_c("b", [_vm._v("Continue")])]
                      )
                    ]
                  )
                : _vm._e()
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CreateAssessmentSectionModal",
        {
          attrs: { isModalVisible: _vm.isModalVisible },
          on: {
            close: function($event) {
              _vm.isModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("h3", [_vm._v("Create Assessment Section")])]
          ),
          _vm._v(" "),
          _vm.isModalVisible === true
            ? _c(
                "div",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  _c("div", { staticClass: "col-8 override-padding" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-lg-4 float-left padding-lr-5",
                        staticStyle: { "padding-left": "0" }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.assessment_section_title,
                              expression: "assessment_section_title"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass:
                            "col-lg-12 padding-lr-5 input-text form-control",
                          staticStyle: {
                            "line-height": "30px",
                            "margin-right": "10px"
                          },
                          attrs: {
                            name: "assessment_section_title",
                            placeholder: "Enter Section Title...",
                            maxlength: "255"
                          },
                          domProps: { value: _vm.assessment_section_title },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.assessment_section_title = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.verrors.firstByRule(
                          "assessment_section_title",
                          "required"
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "margin-bottom-5 validate-warning-msg"
                              },
                              [_vm._v("Assessment Section Title is required")]
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-3 float-left padding-lr-5" },
                      [
                        _c("b-form-select", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "input-text col-lg-12 padding-lr-5",
                          attrs: { name: "scale", options: _vm.scale_options },
                          model: {
                            value: _vm.scale,
                            callback: function($$v) {
                              _vm.scale = $$v
                            },
                            expression: "scale"
                          }
                        }),
                        _vm._v(" "),
                        _vm.verrors.firstByRule("scale", "required")
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "margin-bottom-5 validate-warning-msg"
                              },
                              [_vm._v("Scale is required")]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-3 float-left padding-lr-5" },
                      [
                        _c("b-form-select", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "input-text col-lg-12 padding-lr-5",
                          attrs: {
                            name: "section_type",
                            options: _vm.section_type_options
                          },
                          on: {
                            change: function($event) {
                              return _vm.sectionRangeDisplay()
                            }
                          },
                          model: {
                            value: _vm.section_type,
                            callback: function($$v) {
                              _vm.section_type = $$v
                            },
                            expression: "section_type"
                          }
                        }),
                        _vm._v(" "),
                        _vm.verrors.firstByRule("section_type", "required")
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "margin-bottom-5 validate-warning-msg"
                              },
                              [_vm._v("Type is required")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { clear: "both", "margin-bottom": "10px" }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-11 override-padding" }, [
                    _c("div", { staticClass: "add-statement-heading" }, [
                      _vm._v("\n          Add Statements/Questions\n        ")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-11 override-padding" }, [
                    _c("div", { staticClass: "heading-row" }, [
                      _c("div", { staticClass: "col-1 float-left" }, [
                        _vm._v("#")
                      ]),
                      _vm._v(" "),
                      _vm.section_range_display == true
                        ? _c(
                            "div",
                            { staticClass: "col-2 float-left padding-lr-5" },
                            [_vm._v("Group")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-2 float-left padding-lr-5" },
                        [_vm._v("Type")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-7 float-left padding-lr-5" },
                        [_vm._v("Statement/Question Text")]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-11 override-padding float-left",
                      staticStyle: { "margin-top": "10px" }
                    },
                    _vm._l(_vm.statement_questions, function(list, sindex) {
                      return _c(
                        "div",
                        {
                          key: sindex,
                          staticClass:
                            "statement-row col-12 override-padding float-left",
                          staticStyle: { "margin-bottom": "5px" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "col-1 float-left",
                              staticStyle: {
                                "font-weight": "bold",
                                "margin-top": "5px"
                              }
                            },
                            [_vm._v(_vm._s(sindex + 1))]
                          ),
                          _vm._v(" "),
                          _vm.section_range_display == true
                            ? _c(
                                "div",
                                {
                                  staticClass: "col-2 float-left padding-lr-5"
                                },
                                [
                                  _c("b-form-select", {
                                    ref: "group_" + sindex,
                                    refInFor: true,
                                    staticClass:
                                      "input-text col-lg-12 float-left padding-lr-5",
                                    attrs: { options: _vm.group_options },
                                    model: {
                                      value: list.group,
                                      callback: function($$v) {
                                        _vm.$set(list, "group", $$v)
                                      },
                                      expression: "list.group"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-2 float-left padding-lr-5" },
                            [
                              _c("b-form-select", {
                                ref: "type_" + sindex,
                                refInFor: true,
                                staticClass:
                                  "input-text col-lg-12 float-left padding-lr-5",
                                attrs: { options: _vm.type_options },
                                model: {
                                  value: list.type,
                                  callback: function($$v) {
                                    _vm.$set(list, "type", $$v)
                                  },
                                  expression: "list.type"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-7 float-left padding-lr-5",
                              staticStyle: { "padding-right": "0" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: list.text,
                                    expression: "list.text"
                                  }
                                ],
                                ref: "text_" + sindex,
                                refInFor: true,
                                staticClass:
                                  "col-lg-12 input-text form-control float-left padding-lr-5",
                                staticStyle: { "line-height": "30px" },
                                attrs: {
                                  placeholder: "Enter Statement/Question",
                                  maxlength: "255"
                                },
                                domProps: { value: list.text },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(list, "text", $event.target.value)
                                  }
                                }
                              })
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { clear: "both", "margin-bottom": "5px" }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-11 override-padding" }, [
                    _c(
                      "div",
                      { staticClass: "col-5 override-padding float-left" },
                      [_vm._v("\n           \n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-7 padding-lr-5 float-left add-on",
                        on: {
                          click: function($event) {
                            return _vm.addMoreQuestions()
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-plus spacer-icon",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(" Add Statement/Question (100 Max)\n        ")
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { clear: "both", "margin-bottom": "10px" }
                  }),
                  _vm._v(" "),
                  _vm.section_range_display == true
                    ? _c("div", { staticClass: "col-11 override-padding" }, [
                        _c("div", { staticClass: "add-statement-heading" }, [
                          _vm._v(
                            "\n          Enter Output Ranges and Text\n        "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkVisible("A"),
                          expression: "checkVisible('A')"
                        }
                      ],
                      staticClass: "col-11 overridepadding collapse-wrapper"
                    },
                    [
                      _c(
                        "b-link",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle",
                              value: "collapse-A",
                              expression: "'collapse-A'"
                            }
                          ]
                        },
                        [
                          _c("div", [
                            _vm._v("\n            Group A\n            "),
                            _c("i", {
                              staticClass: "fa fa-angle-up",
                              attrs: { "aria-hidden": "true" }
                            })
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkVisible("A"),
                          expression: "checkVisible('A')"
                        }
                      ],
                      staticClass: "mt-2",
                      attrs: { id: "collapse-A", visible: "" }
                    },
                    [
                      _c("div", { staticClass: "col-11 override-padding" }, [
                        _c("div", { staticClass: "heading-row" }, [
                          _c(
                            "div",
                            { staticClass: "col-1 float-left padding-lr-5" },
                            [_vm._v("From")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-1 float-left padding-lr-5 text-align-center"
                            },
                            [_vm._v(">/<")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-1 float-left padding-lr-5" },
                            [_vm._v("To")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-9 float-left padding-lr-5" },
                            [_vm._v("Output Text")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-11 override-padding float-left",
                          staticStyle: { "margin-top": "10px" }
                        },
                        _vm._l(_vm.group_a_range, function(list, aindex) {
                          return _c(
                            "div",
                            {
                              key: aindex,
                              staticClass:
                                "statement-row col-12 override-padding float-left",
                              staticStyle: { "margin-bottom": "5px" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-1 float-left padding-lr-5"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: list.from,
                                        expression: "list.from"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-12 input-text form-control float-left padding-lr-5",
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { maxlength: "5" },
                                    domProps: { value: list.from },
                                    on: {
                                      blur: function($event) {
                                        return _vm.checkRangeNumbers(
                                          aindex,
                                          "From",
                                          "A"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          list,
                                          "from",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-1 float-left padding-lr-5 text-align-center",
                                  staticStyle: { "margin-top": "5px" }
                                },
                                [_vm._v("\n            -\n          ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-1 float-left padding-lr-5"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: list.to,
                                        expression: "list.to"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-12 input-text form-control float-left padding-lr-5",
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { maxlength: "5" },
                                    domProps: { value: list.to },
                                    on: {
                                      blur: function($event) {
                                        return _vm.checkRangeNumbers(
                                          aindex,
                                          "To",
                                          "A"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          list,
                                          "to",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-9 float-left padding-lr-5",
                                  staticStyle: { "padding-right": "0" }
                                },
                                [
                                  _c("vue-editor", {
                                    attrs: { editorToolbar: _vm.customToolbar },
                                    model: {
                                      value: list.text,
                                      callback: function($$v) {
                                        _vm.$set(list, "text", $$v)
                                      },
                                      expression: "list.text"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: { clear: "both", "margin-bottom": "5px" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-11 override-padding" }, [
                        _c(
                          "div",
                          { staticClass: "col-3 override-padding float-left" },
                          [_vm._v("\n           \n        ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-9 padding-lr-5 float-left add-on",
                            on: {
                              click: function($event) {
                                return _vm.addMoreOutputText("A")
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-plus spacer-icon",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticStyle: { "font-style": "italic" } },
                              [_vm._v("Add Score Range (25 Max) ")]
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { clear: "both", "margin-bottom": "10px" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkVisible("B"),
                          expression: "checkVisible('B')"
                        }
                      ],
                      staticClass: "col-11 overridepadding collapse-wrapper"
                    },
                    [
                      _c(
                        "b-link",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle",
                              value: "collapse-B",
                              expression: "'collapse-B'"
                            }
                          ]
                        },
                        [
                          _c("div", [
                            _vm._v("\n            Group B\n            "),
                            _c("i", {
                              staticClass: "fa fa-angle-up",
                              attrs: { "aria-hidden": "true" }
                            })
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkVisible("B"),
                          expression: "checkVisible('B')"
                        }
                      ],
                      staticClass: "mt-2",
                      attrs: { id: "collapse-B", visible: "" }
                    },
                    [
                      _c("div", { staticClass: "col-11 override-padding" }, [
                        _c("div", { staticClass: "heading-row" }, [
                          _c(
                            "div",
                            { staticClass: "col-1 float-left padding-lr-5" },
                            [_vm._v("From")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-1 float-left padding-lr-5 text-align-center"
                            },
                            [_vm._v(">/<")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-1 float-left padding-lr-5" },
                            [_vm._v("To")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-9 float-left padding-lr-5" },
                            [_vm._v("Output Text")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-11 override-padding float-left",
                          staticStyle: { "margin-top": "10px" }
                        },
                        _vm._l(_vm.group_b_range, function(list, bindex) {
                          return _c(
                            "div",
                            {
                              key: bindex,
                              staticClass:
                                "statement-row col-12 override-padding float-left",
                              staticStyle: { "margin-bottom": "5px" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-1 float-left padding-lr-5"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: list.from,
                                        expression: "list.from"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-12 input-text form-control float-left padding-lr-5",
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { maxlength: "5" },
                                    domProps: { value: list.from },
                                    on: {
                                      blur: function($event) {
                                        return _vm.checkRangeNumbers(
                                          bindex,
                                          "From",
                                          "B"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          list,
                                          "from",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-1 float-left padding-lr-5 text-align-center",
                                  staticStyle: { "margin-top": "5px" }
                                },
                                [_vm._v("\n            -\n          ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-1 float-left padding-lr-5"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: list.to,
                                        expression: "list.to"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-12 input-text form-control float-left padding-lr-5",
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { maxlength: "5" },
                                    domProps: { value: list.to },
                                    on: {
                                      blur: function($event) {
                                        return _vm.checkRangeNumbers(
                                          bindex,
                                          "To",
                                          "B"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          list,
                                          "to",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-9 float-left padding-lr-5",
                                  staticStyle: { "padding-right": "0" }
                                },
                                [
                                  _c("vue-editor", {
                                    attrs: { editorToolbar: _vm.customToolbar },
                                    model: {
                                      value: list.text,
                                      callback: function($$v) {
                                        _vm.$set(list, "text", $$v)
                                      },
                                      expression: "list.text"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: { clear: "both", "margin-bottom": "5px" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-11 override-padding" }, [
                        _c(
                          "div",
                          { staticClass: "col-3 override-padding float-left" },
                          [_vm._v("\n           \n        ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-9 padding-lr-5 float-left add-on",
                            on: {
                              click: function($event) {
                                return _vm.addMoreOutputText("B")
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-plus spacer-icon",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticStyle: { "font-style": "italic" } },
                              [_vm._v("Add Score Range (25 Max) ")]
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { clear: "both", "margin-bottom": "10px" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkVisible("C"),
                          expression: "checkVisible('C')"
                        }
                      ],
                      staticClass: "col-11 overridepadding collapse-wrapper"
                    },
                    [
                      _c(
                        "b-link",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle",
                              value: "collapse-C",
                              expression: "'collapse-C'"
                            }
                          ]
                        },
                        [
                          _c("div", [
                            _vm._v("\n            Group C\n            "),
                            _c("i", {
                              staticClass: "fa fa-angle-up",
                              attrs: { "aria-hidden": "true" }
                            })
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkVisible("C"),
                          expression: "checkVisible('C')"
                        }
                      ],
                      staticClass: "mt-2",
                      attrs: { id: "collapse-C", visible: "" }
                    },
                    [
                      _c("div", { staticClass: "col-11 override-padding" }, [
                        _c("div", { staticClass: "heading-row" }, [
                          _c(
                            "div",
                            { staticClass: "col-1 float-left padding-lr-5" },
                            [_vm._v("From")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-1 float-left padding-lr-5 text-align-center"
                            },
                            [_vm._v(">/<")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-1 float-left padding-lr-5" },
                            [_vm._v("To")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-9 float-left padding-lr-5" },
                            [_vm._v("Output Text")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-11 override-padding float-left",
                          staticStyle: { "margin-top": "10px" }
                        },
                        _vm._l(_vm.group_c_range, function(list, aindex) {
                          return _c(
                            "div",
                            {
                              key: aindex,
                              staticClass:
                                "statement-row col-12 override-padding float-left",
                              staticStyle: { "margin-bottom": "5px" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-1 float-left padding-lr-5"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: list.from,
                                        expression: "list.from"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-12 input-text form-control float-left padding-lr-5",
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { maxlength: "5" },
                                    domProps: { value: list.from },
                                    on: {
                                      blur: function($event) {
                                        return _vm.checkRangeNumbers(
                                          aindex,
                                          "From",
                                          "C"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          list,
                                          "from",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-1 float-left padding-lr-5 text-align-center",
                                  staticStyle: { "margin-top": "5px" }
                                },
                                [_vm._v("\n            -\n          ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-1 float-left padding-lr-5"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: list.to,
                                        expression: "list.to"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-12 input-text form-control float-left padding-lr-5",
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { maxlength: "5" },
                                    domProps: { value: list.to },
                                    on: {
                                      blur: function($event) {
                                        return _vm.checkRangeNumbers(
                                          aindex,
                                          "To",
                                          "C"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          list,
                                          "to",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-9 float-left padding-lr-5",
                                  staticStyle: { "padding-right": "0" }
                                },
                                [
                                  _c("vue-editor", {
                                    attrs: { editorToolbar: _vm.customToolbar },
                                    model: {
                                      value: list.text,
                                      callback: function($$v) {
                                        _vm.$set(list, "text", $$v)
                                      },
                                      expression: "list.text"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: { clear: "both", "margin-bottom": "5px" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-11 override-padding" }, [
                        _c(
                          "div",
                          { staticClass: "col-3 override-padding float-left" },
                          [_vm._v("\n           \n        ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-9 padding-lr-5 float-left add-on",
                            on: {
                              click: function($event) {
                                return _vm.addMoreOutputText("C")
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-plus spacer-icon",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticStyle: { "font-style": "italic" } },
                              [_vm._v("Add Score Range (25 Max) ")]
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { clear: "both", "margin-bottom": "10px" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkVisible("D"),
                          expression: "checkVisible('D')"
                        }
                      ],
                      staticClass: "col-11 overridepadding collapse-wrapper"
                    },
                    [
                      _c(
                        "b-link",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle",
                              value: "collapse-D",
                              expression: "'collapse-D'"
                            }
                          ]
                        },
                        [
                          _c("div", [
                            _vm._v("\n            Group D\n            "),
                            _c("i", {
                              staticClass: "fa fa-angle-up",
                              attrs: { "aria-hidden": "true" }
                            })
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkVisible("D"),
                          expression: "checkVisible('D')"
                        }
                      ],
                      staticClass: "mt-2",
                      attrs: { id: "collapse-D", visible: "" }
                    },
                    [
                      _c("div", { staticClass: "col-11 override-padding" }, [
                        _c("div", { staticClass: "heading-row" }, [
                          _c(
                            "div",
                            { staticClass: "col-1 float-left padding-lr-5" },
                            [_vm._v("From")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-1 float-left padding-lr-5 text-align-center"
                            },
                            [_vm._v(">/<")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-1 float-left padding-lr-5" },
                            [_vm._v("To")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-9 float-left padding-lr-5" },
                            [_vm._v("Output Text")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-11 override-padding float-left",
                          staticStyle: { "margin-top": "10px" }
                        },
                        _vm._l(_vm.group_d_range, function(list, aindex) {
                          return _c(
                            "div",
                            {
                              key: aindex,
                              staticClass:
                                "statement-row col-12 override-padding float-left",
                              staticStyle: { "margin-bottom": "5px" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-1 float-left padding-lr-5"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: list.from,
                                        expression: "list.from"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-12 input-text form-control float-left padding-lr-5",
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { maxlength: "5" },
                                    domProps: { value: list.from },
                                    on: {
                                      blur: function($event) {
                                        return _vm.checkRangeNumbers(
                                          aindex,
                                          "From",
                                          "D"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          list,
                                          "from",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-1 float-left padding-lr-5 text-align-center",
                                  staticStyle: { "margin-top": "5px" }
                                },
                                [_vm._v("\n            -\n          ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-1 float-left padding-lr-5"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: list.to,
                                        expression: "list.to"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-12 input-text form-control float-left padding-lr-5",
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { maxlength: "5" },
                                    domProps: { value: list.to },
                                    on: {
                                      blur: function($event) {
                                        return _vm.checkRangeNumbers(
                                          aindex,
                                          "To",
                                          "D"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          list,
                                          "to",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-9 float-left padding-lr-5",
                                  staticStyle: { "padding-right": "0" }
                                },
                                [
                                  _c("vue-editor", {
                                    attrs: { editorToolbar: _vm.customToolbar },
                                    model: {
                                      value: list.text,
                                      callback: function($$v) {
                                        _vm.$set(list, "text", $$v)
                                      },
                                      expression: "list.text"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: { clear: "both", "margin-bottom": "5px" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-11 override-padding" }, [
                        _c(
                          "div",
                          { staticClass: "col-3 override-padding float-left" },
                          [_vm._v("\n           \n        ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-9 padding-lr-5 float-left add-on",
                            on: {
                              click: function($event) {
                                return _vm.addMoreOutputText("D")
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-plus spacer-icon",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticStyle: { "font-style": "italic" } },
                              [_vm._v("Add Score Range (25 Max) ")]
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { clear: "both", "margin-bottom": "10px" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkVisible("E"),
                          expression: "checkVisible('E')"
                        }
                      ],
                      staticClass: "col-11 overridepadding collapse-wrapper"
                    },
                    [
                      _c(
                        "b-link",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle",
                              value: "collapse-E",
                              expression: "'collapse-E'"
                            }
                          ]
                        },
                        [
                          _c("div", [
                            _vm._v("\n            Group E\n            "),
                            _c("i", {
                              staticClass: "fa fa-angle-up",
                              attrs: { "aria-hidden": "true" }
                            })
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkVisible("E"),
                          expression: "checkVisible('E')"
                        }
                      ],
                      staticClass: "mt-2",
                      attrs: { id: "collapse-E", visible: "" }
                    },
                    [
                      _c("div", { staticClass: "col-11 override-padding" }, [
                        _c("div", { staticClass: "heading-row" }, [
                          _c(
                            "div",
                            { staticClass: "col-1 float-left padding-lr-5" },
                            [_vm._v("From")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-1 float-left padding-lr-5 text-align-center"
                            },
                            [_vm._v(">/<")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-1 float-left padding-lr-5" },
                            [_vm._v("To")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-9 float-left padding-lr-5" },
                            [_vm._v("Output Text")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-11 override-padding float-left",
                          staticStyle: { "margin-top": "10px" }
                        },
                        _vm._l(_vm.group_e_range, function(list, aindex) {
                          return _c(
                            "div",
                            {
                              key: aindex,
                              staticClass:
                                "statement-row col-12 override-padding float-left",
                              staticStyle: { "margin-bottom": "5px" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-1 float-left padding-lr-5"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: list.from,
                                        expression: "list.from"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-12 input-text form-control float-left padding-lr-5",
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { maxlength: "5" },
                                    domProps: { value: list.from },
                                    on: {
                                      blur: function($event) {
                                        return _vm.checkRangeNumbers(
                                          aindex,
                                          "From",
                                          "E"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          list,
                                          "from",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-1 float-left padding-lr-5 text-align-center",
                                  staticStyle: { "margin-top": "5px" }
                                },
                                [_vm._v("\n            -\n          ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-1 float-left padding-lr-5"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: list.to,
                                        expression: "list.to"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-12 input-text form-control float-left padding-lr-5",
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { maxlength: "5" },
                                    domProps: { value: list.to },
                                    on: {
                                      blur: function($event) {
                                        return _vm.checkRangeNumbers(
                                          aindex,
                                          "To",
                                          "E"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          list,
                                          "to",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-9 float-left padding-lr-5",
                                  staticStyle: { "padding-right": "0" }
                                },
                                [
                                  _c("vue-editor", {
                                    attrs: { editorToolbar: _vm.customToolbar },
                                    model: {
                                      value: list.text,
                                      callback: function($$v) {
                                        _vm.$set(list, "text", $$v)
                                      },
                                      expression: "list.text"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: { clear: "both", "margin-bottom": "5px" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-11 override-padding" }, [
                        _c(
                          "div",
                          { staticClass: "col-3 override-padding float-left" },
                          [_vm._v("\n           \n        ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-9 padding-lr-5 float-left add-on",
                            on: {
                              click: function($event) {
                                return _vm.addMoreOutputText("E")
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-plus spacer-icon",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticStyle: { "font-style": "italic" } },
                              [_vm._v("Add Score Range (25 Max) ")]
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { clear: "both", "margin-bottom": "10px" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkVisible("F"),
                          expression: "checkVisible('F')"
                        }
                      ],
                      staticClass: "col-11 overridepadding collapse-wrapper"
                    },
                    [
                      _c(
                        "b-link",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle",
                              value: "collapse-F",
                              expression: "'collapse-F'"
                            }
                          ]
                        },
                        [
                          _c("div", [
                            _vm._v("\n            Group F\n            "),
                            _c("i", {
                              staticClass: "fa fa-angle-up",
                              attrs: { "aria-hidden": "true" }
                            })
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkVisible("F"),
                          expression: "checkVisible('F')"
                        }
                      ],
                      staticClass: "mt-2",
                      attrs: { id: "collapse-F", visible: "" }
                    },
                    [
                      _c("div", { staticClass: "col-11 override-padding" }, [
                        _c("div", { staticClass: "heading-row" }, [
                          _c(
                            "div",
                            { staticClass: "col-1 float-left padding-lr-5" },
                            [_vm._v("From")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-1 float-left padding-lr-5 text-align-center"
                            },
                            [_vm._v(">/<")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-1 float-left padding-lr-5" },
                            [_vm._v("To")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-9 float-left padding-lr-5" },
                            [_vm._v("Output Text")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-11 override-padding float-left",
                          staticStyle: { "margin-top": "10px" }
                        },
                        _vm._l(_vm.group_f_range, function(list, aindex) {
                          return _c(
                            "div",
                            {
                              key: aindex,
                              staticClass:
                                "statement-row col-12 override-padding float-left",
                              staticStyle: { "margin-bottom": "5px" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-1 float-left padding-lr-5"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: list.from,
                                        expression: "list.from"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-12 input-text form-control float-left padding-lr-5",
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { maxlength: "5" },
                                    domProps: { value: list.from },
                                    on: {
                                      blur: function($event) {
                                        return _vm.checkRangeNumbers(
                                          aindex,
                                          "From",
                                          "F"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          list,
                                          "from",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-1 float-left padding-lr-5 text-align-center",
                                  staticStyle: { "margin-top": "5px" }
                                },
                                [_vm._v("\n            -\n          ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-1 float-left padding-lr-5"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: list.to,
                                        expression: "list.to"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-12 input-text form-control float-left padding-lr-5",
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { maxlength: "5" },
                                    domProps: { value: list.to },
                                    on: {
                                      blur: function($event) {
                                        return _vm.checkRangeNumbers(
                                          aindex,
                                          "To",
                                          "F"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          list,
                                          "to",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-9 float-left padding-lr-5",
                                  staticStyle: { "padding-right": "0" }
                                },
                                [
                                  _c("vue-editor", {
                                    attrs: { editorToolbar: _vm.customToolbar },
                                    model: {
                                      value: list.text,
                                      callback: function($$v) {
                                        _vm.$set(list, "text", $$v)
                                      },
                                      expression: "list.text"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: { clear: "both", "margin-bottom": "5px" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-11 override-padding" }, [
                        _c(
                          "div",
                          { staticClass: "col-3 override-padding float-left" },
                          [_vm._v("\n           \n        ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-9 padding-lr-5 float-left add-on",
                            on: {
                              click: function($event) {
                                return _vm.addMoreOutputText("F")
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-plus spacer-icon",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticStyle: { "font-style": "italic" } },
                              [_vm._v("Add Score Range (25 Max) ")]
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { clear: "both", "margin-bottom": "10px" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkVisible("G"),
                          expression: "checkVisible('G')"
                        }
                      ],
                      staticClass: "col-11 overridepadding collapse-wrapper"
                    },
                    [
                      _c(
                        "b-link",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle",
                              value: "collapse-G",
                              expression: "'collapse-G'"
                            }
                          ]
                        },
                        [
                          _c("div", [
                            _vm._v("\n            Group G\n            "),
                            _c("i", {
                              staticClass: "fa fa-angle-up",
                              attrs: { "aria-hidden": "true" }
                            })
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkVisible("G"),
                          expression: "checkVisible('G')"
                        }
                      ],
                      staticClass: "mt-2",
                      attrs: { id: "collapse-G", visible: "" }
                    },
                    [
                      _c("div", { staticClass: "col-11 override-padding" }, [
                        _c("div", { staticClass: "heading-row" }, [
                          _c(
                            "div",
                            { staticClass: "col-1 float-left padding-lr-5" },
                            [_vm._v("From")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-1 float-left padding-lr-5 text-align-center"
                            },
                            [_vm._v(">/<")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-1 float-left padding-lr-5" },
                            [_vm._v("To")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-9 float-left padding-lr-5" },
                            [_vm._v("Output Text")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-11 override-padding float-left",
                          staticStyle: { "margin-top": "10px" }
                        },
                        _vm._l(_vm.group_g_range, function(list, aindex) {
                          return _c(
                            "div",
                            {
                              key: aindex,
                              staticClass:
                                "statement-row col-12 override-padding float-left",
                              staticStyle: { "margin-bottom": "5px" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-1 float-left padding-lr-5"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: list.from,
                                        expression: "list.from"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-12 input-text form-control float-left padding-lr-5",
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { maxlength: "5" },
                                    domProps: { value: list.from },
                                    on: {
                                      blur: function($event) {
                                        return _vm.checkRangeNumbers(
                                          aindex,
                                          "From",
                                          "G"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          list,
                                          "from",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-1 float-left padding-lr-5 text-align-center",
                                  staticStyle: { "margin-top": "5px" }
                                },
                                [_vm._v("\n            -\n          ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-1 float-left padding-lr-5"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: list.to,
                                        expression: "list.to"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-12 input-text form-control float-left padding-lr-5",
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { maxlength: "5" },
                                    domProps: { value: list.to },
                                    on: {
                                      blur: function($event) {
                                        return _vm.checkRangeNumbers(
                                          aindex,
                                          "To",
                                          "G"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          list,
                                          "to",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-9 float-left padding-lr-5",
                                  staticStyle: { "padding-right": "0" }
                                },
                                [
                                  _c("vue-editor", {
                                    attrs: { editorToolbar: _vm.customToolbar },
                                    model: {
                                      value: list.text,
                                      callback: function($$v) {
                                        _vm.$set(list, "text", $$v)
                                      },
                                      expression: "list.text"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: { clear: "both", "margin-bottom": "5px" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-11 override-padding" }, [
                        _c(
                          "div",
                          { staticClass: "col-3 override-padding float-left" },
                          [_vm._v("\n           \n        ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-9 padding-lr-5 float-left add-on",
                            on: {
                              click: function($event) {
                                return _vm.addMoreOutputText("G")
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-plus spacer-icon",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticStyle: { "font-style": "italic" } },
                              [_vm._v("Add Score Range (25 Max) ")]
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { clear: "both", "margin-bottom": "10px" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkVisible("H"),
                          expression: "checkVisible('H')"
                        }
                      ],
                      staticClass: "col-11 overridepadding collapse-wrapper"
                    },
                    [
                      _c(
                        "b-link",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle",
                              value: "collapse-H",
                              expression: "'collapse-H'"
                            }
                          ]
                        },
                        [
                          _c("div", [
                            _vm._v("\n            Group H\n            "),
                            _c("i", {
                              staticClass: "fa fa-angle-up",
                              attrs: { "aria-hidden": "true" }
                            })
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkVisible("H"),
                          expression: "checkVisible('H')"
                        }
                      ],
                      staticClass: "mt-2",
                      attrs: { id: "collapse-H", visible: "" }
                    },
                    [
                      _c("div", { staticClass: "col-11 override-padding" }, [
                        _c("div", { staticClass: "heading-row" }, [
                          _c(
                            "div",
                            { staticClass: "col-1 float-left padding-lr-5" },
                            [_vm._v("From")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-1 float-left padding-lr-5 text-align-center"
                            },
                            [_vm._v(">/<")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-1 float-left padding-lr-5" },
                            [_vm._v("To")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-9 float-left padding-lr-5" },
                            [_vm._v("Output Text")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-11 override-padding float-left",
                          staticStyle: { "margin-top": "10px" }
                        },
                        _vm._l(_vm.group_h_range, function(list, aindex) {
                          return _c(
                            "div",
                            {
                              key: aindex,
                              staticClass:
                                "statement-row col-12 override-padding float-left",
                              staticStyle: { "margin-bottom": "5px" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-1 float-left padding-lr-5"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: list.from,
                                        expression: "list.from"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-12 input-text form-control float-left padding-lr-5",
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { maxlength: "5" },
                                    domProps: { value: list.from },
                                    on: {
                                      blur: function($event) {
                                        return _vm.checkRangeNumbers(
                                          aindex,
                                          "From",
                                          "H"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          list,
                                          "from",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-1 float-left padding-lr-5 text-align-center",
                                  staticStyle: { "margin-top": "5px" }
                                },
                                [_vm._v("\n            -\n          ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-1 float-left padding-lr-5"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: list.to,
                                        expression: "list.to"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-12 input-text form-control float-left padding-lr-5",
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { maxlength: "5" },
                                    domProps: { value: list.to },
                                    on: {
                                      blur: function($event) {
                                        return _vm.checkRangeNumbers(
                                          aindex,
                                          "To",
                                          "H"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          list,
                                          "to",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-9 float-left padding-lr-5",
                                  staticStyle: { "padding-right": "0" }
                                },
                                [
                                  _c("vue-editor", {
                                    attrs: { editorToolbar: _vm.customToolbar },
                                    model: {
                                      value: list.text,
                                      callback: function($$v) {
                                        _vm.$set(list, "text", $$v)
                                      },
                                      expression: "list.text"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: { clear: "both", "margin-bottom": "5px" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-11 override-padding" }, [
                        _c(
                          "div",
                          { staticClass: "col-3 override-padding float-left" },
                          [_vm._v("\n           \n        ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-9 padding-lr-5 float-left add-on",
                            on: {
                              click: function($event) {
                                return _vm.addMoreOutputText("H")
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-plus spacer-icon",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticStyle: { "font-style": "italic" } },
                              [_vm._v("Add Score Range (25 Max) ")]
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { clear: "both", "margin-bottom": "10px" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkVisible("I"),
                          expression: "checkVisible('I')"
                        }
                      ],
                      staticClass: "col-11 overridepadding collapse-wrapper"
                    },
                    [
                      _c(
                        "b-link",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle",
                              value: "collapse-I",
                              expression: "'collapse-I'"
                            }
                          ]
                        },
                        [
                          _c("div", [
                            _vm._v("\n            Group I\n            "),
                            _c("i", {
                              staticClass: "fa fa-angle-up",
                              attrs: { "aria-hidden": "true" }
                            })
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkVisible("I"),
                          expression: "checkVisible('I')"
                        }
                      ],
                      staticClass: "mt-2",
                      attrs: { id: "collapse-I", visible: "" }
                    },
                    [
                      _c("div", { staticClass: "col-11 override-padding" }, [
                        _c("div", { staticClass: "heading-row" }, [
                          _c(
                            "div",
                            { staticClass: "col-1 float-left padding-lr-5" },
                            [_vm._v("From")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-1 float-left padding-lr-5 text-align-center"
                            },
                            [_vm._v(">/<")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-1 float-left padding-lr-5" },
                            [_vm._v("To")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-9 float-left padding-lr-5" },
                            [_vm._v("Output Text")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-11 override-padding float-left",
                          staticStyle: { "margin-top": "10px" }
                        },
                        _vm._l(_vm.group_i_range, function(list, aindex) {
                          return _c(
                            "div",
                            {
                              key: aindex,
                              staticClass:
                                "statement-row col-12 override-padding float-left",
                              staticStyle: { "margin-bottom": "5px" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-1 float-left padding-lr-5"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: list.from,
                                        expression: "list.from"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-12 input-text form-control float-left padding-lr-5",
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { maxlength: "5" },
                                    domProps: { value: list.from },
                                    on: {
                                      blur: function($event) {
                                        return _vm.checkRangeNumbers(
                                          aindex,
                                          "From",
                                          "I"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          list,
                                          "from",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-1 float-left padding-lr-5 text-align-center",
                                  staticStyle: { "margin-top": "5px" }
                                },
                                [_vm._v("\n            -\n          ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-1 float-left padding-lr-5"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: list.to,
                                        expression: "list.to"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-12 input-text form-control float-left padding-lr-5",
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { maxlength: "5" },
                                    domProps: { value: list.to },
                                    on: {
                                      blur: function($event) {
                                        return _vm.checkRangeNumbers(
                                          aindex,
                                          "To",
                                          "I"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          list,
                                          "to",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-9 float-left padding-lr-5",
                                  staticStyle: { "padding-right": "0" }
                                },
                                [
                                  _c("vue-editor", {
                                    attrs: { editorToolbar: _vm.customToolbar },
                                    model: {
                                      value: list.text,
                                      callback: function($$v) {
                                        _vm.$set(list, "text", $$v)
                                      },
                                      expression: "list.text"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: { clear: "both", "margin-bottom": "5px" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-11 override-padding" }, [
                        _c(
                          "div",
                          { staticClass: "col-3 override-padding float-left" },
                          [_vm._v("\n           \n        ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-9 padding-lr-5 float-left add-on",
                            on: {
                              click: function($event) {
                                return _vm.addMoreOutputText("I")
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-plus spacer-icon",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticStyle: { "font-style": "italic" } },
                              [_vm._v("Add Score Range (25 Max) ")]
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { clear: "both", "margin-bottom": "10px" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkVisible("J"),
                          expression: "checkVisible('J')"
                        }
                      ],
                      staticClass: "col-11 overridepadding collapse-wrapper"
                    },
                    [
                      _c(
                        "b-link",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle",
                              value: "collapse-J",
                              expression: "'collapse-J'"
                            }
                          ]
                        },
                        [
                          _c("div", [
                            _vm._v("\n            Group J\n            "),
                            _c("i", {
                              staticClass: "fa fa-angle-up",
                              attrs: { "aria-hidden": "true" }
                            })
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkVisible("J"),
                          expression: "checkVisible('J')"
                        }
                      ],
                      staticClass: "mt-2",
                      attrs: { id: "collapse-J", visible: "" }
                    },
                    [
                      _c("div", { staticClass: "col-11 override-padding" }, [
                        _c("div", { staticClass: "heading-row" }, [
                          _c(
                            "div",
                            { staticClass: "col-1 float-left padding-lr-5" },
                            [_vm._v("From")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-1 float-left padding-lr-5 text-align-center"
                            },
                            [_vm._v(">/<")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-1 float-left padding-lr-5" },
                            [_vm._v("To")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-9 float-left padding-lr-5" },
                            [_vm._v("Output Text")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-11 override-padding float-left",
                          staticStyle: { "margin-top": "10px" }
                        },
                        _vm._l(_vm.group_j_range, function(list, aindex) {
                          return _c(
                            "div",
                            {
                              key: aindex,
                              staticClass:
                                "statement-row col-12 override-padding float-left",
                              staticStyle: { "margin-bottom": "5px" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-1 float-left padding-lr-5"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: list.from,
                                        expression: "list.from"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-12 input-text form-control float-left padding-lr-5",
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { maxlength: "5" },
                                    domProps: { value: list.from },
                                    on: {
                                      blur: function($event) {
                                        return _vm.checkRangeNumbers(
                                          aindex,
                                          "From",
                                          "J"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          list,
                                          "from",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-1 float-left padding-lr-5 text-align-center",
                                  staticStyle: { "margin-top": "5px" }
                                },
                                [_vm._v("\n            -\n          ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-1 float-left padding-lr-5"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: list.to,
                                        expression: "list.to"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-12 input-text form-control float-left padding-lr-5",
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { maxlength: "5" },
                                    domProps: { value: list.to },
                                    on: {
                                      blur: function($event) {
                                        return _vm.checkRangeNumbers(
                                          aindex,
                                          "To",
                                          "J"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          list,
                                          "to",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-9 float-left padding-lr-5",
                                  staticStyle: { "padding-right": "0" }
                                },
                                [
                                  _c("vue-editor", {
                                    attrs: { editorToolbar: _vm.customToolbar },
                                    model: {
                                      value: list.text,
                                      callback: function($$v) {
                                        _vm.$set(list, "text", $$v)
                                      },
                                      expression: "list.text"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: { clear: "both", "margin-bottom": "5px" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-11 override-padding" }, [
                        _c(
                          "div",
                          { staticClass: "col-3 override-padding float-left" },
                          [_vm._v("\n           \n        ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-9 padding-lr-5 float-left add-on",
                            on: {
                              click: function($event) {
                                return _vm.addMoreOutputText("J")
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-plus spacer-icon",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticStyle: { "font-style": "italic" } },
                              [_vm._v("Add Score Range (25 Max) ")]
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { clear: "both", "margin-bottom": "10px" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkVisible("K"),
                          expression: "checkVisible('K')"
                        }
                      ],
                      staticClass: "col-11 overridepadding collapse-wrapper"
                    },
                    [
                      _c(
                        "b-link",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle",
                              value: "collapse-K",
                              expression: "'collapse-K'"
                            }
                          ]
                        },
                        [
                          _c("div", [
                            _vm._v("\n            Group K\n            "),
                            _c("i", {
                              staticClass: "fa fa-angle-up",
                              attrs: { "aria-hidden": "true" }
                            })
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkVisible("K"),
                          expression: "checkVisible('K')"
                        }
                      ],
                      staticClass: "mt-2",
                      attrs: { id: "collapse-K", visible: "" }
                    },
                    [
                      _c("div", { staticClass: "col-11 override-padding" }, [
                        _c("div", { staticClass: "heading-row" }, [
                          _c(
                            "div",
                            { staticClass: "col-1 float-left padding-lr-5" },
                            [_vm._v("From")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-1 float-left padding-lr-5 text-align-center"
                            },
                            [_vm._v(">/<")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-1 float-left padding-lr-5" },
                            [_vm._v("To")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-9 float-left padding-lr-5" },
                            [_vm._v("Output Text")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-11 override-padding float-left",
                          staticStyle: { "margin-top": "10px" }
                        },
                        _vm._l(_vm.group_k_range, function(list, aindex) {
                          return _c(
                            "div",
                            {
                              key: aindex,
                              staticClass:
                                "statement-row col-12 override-padding float-left",
                              staticStyle: { "margin-bottom": "5px" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-1 float-left padding-lr-5"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: list.from,
                                        expression: "list.from"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-12 input-text form-control float-left padding-lr-5",
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { maxlength: "5" },
                                    domProps: { value: list.from },
                                    on: {
                                      blur: function($event) {
                                        return _vm.checkRangeNumbers(
                                          aindex,
                                          "From",
                                          "K"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          list,
                                          "from",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-1 float-left padding-lr-5 text-align-center",
                                  staticStyle: { "margin-top": "5px" }
                                },
                                [_vm._v("\n            -\n          ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-1 float-left padding-lr-5"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: list.to,
                                        expression: "list.to"
                                      }
                                    ],
                                    staticClass:
                                      "col-lg-12 input-text form-control float-left padding-lr-5",
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { maxlength: "5" },
                                    domProps: { value: list.to },
                                    on: {
                                      blur: function($event) {
                                        return _vm.checkRangeNumbers(
                                          aindex,
                                          "To",
                                          "K"
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          list,
                                          "to",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-9 float-left padding-lr-5",
                                  staticStyle: { "padding-right": "0" }
                                },
                                [
                                  _c("vue-editor", {
                                    attrs: { editorToolbar: _vm.customToolbar },
                                    model: {
                                      value: list.text,
                                      callback: function($$v) {
                                        _vm.$set(list, "text", $$v)
                                      },
                                      expression: "list.text"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: { clear: "both", "margin-bottom": "5px" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-11 override-padding" }, [
                        _c(
                          "div",
                          { staticClass: "col-3 override-padding float-left" },
                          [_vm._v("\n           \n        ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-9 padding-lr-5 float-left add-on",
                            on: {
                              click: function($event) {
                                return _vm.addMoreOutputText("K")
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-plus spacer-icon",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticStyle: { "font-style": "italic" } },
                              [_vm._v("Add Score Range (25 Max) ")]
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticStyle: { clear: "both", "margin-bottom": "10px" }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-11 override-padding" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-2 col-md-4 col-4 padding-lr-5 float-right",
                        staticStyle: { "padding-right": "0px" }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-red col-12 override-padding",
                            staticStyle: {
                              "margin-top": "2px",
                              height: "32px",
                              "border-radius": "10px"
                            },
                            on: {
                              click: function($event) {
                                return _vm.createAssessmentSection("PUBLISH")
                              }
                            }
                          },
                          [_vm._v("Publish")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-lg-2 col-md-4 col-4 padding-lr-5 float-right"
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-white col-12 padding-lr-5",
                            staticStyle: {
                              height: "32px",
                              "border-radius": "10px",
                              "margin-top": "2px"
                            },
                            on: {
                              click: function($event) {
                                return _vm.createAssessmentSection("DRAFT")
                              }
                            }
                          },
                          [_vm._v("Save as Draft")]
                        )
                      ]
                    )
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "col-3 override-padding",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ]
      ),
      _vm._v(" "),
      _c("EditAssessmentSectionModal", {
        ref: "EditModal",
        attrs: {
          isModalVisible: _vm.isEditModalVisible,
          sectionId: _vm.editSectionId
        },
        on: {
          close: function($event) {
            _vm.isEditModalVisible = false
          }
        }
      }),
      _vm._v(" "),
      _c(
        "DeleteModal",
        {
          attrs: { isModalVisible: _vm.isDeleteModalVisible, id: _vm.id },
          on: {
            close: function($event) {
              _vm.isDeleteModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_vm._v("Are you sure you want to delete?")]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "body" }, slot: "body" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-3 override-padding",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "button",
                {
                  staticClass: "left col-12 btn btn-red",
                  on: {
                    click: function($event) {
                      return _vm.deleteSection(_vm.id)
                    }
                  }
                },
                [_vm._v("Confirm")]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "DeactivateModal",
        {
          attrs: {
            isModalVisible: _vm.isDeactivateModalVisible,
            id: _vm.deactivateId
          },
          on: {
            close: function($event) {
              _vm.isDeactivateModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_vm._v("Are you sure you want to deactivate? ")]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "body" }, slot: "body" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-3 override-padding",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "button",
                {
                  staticClass: "left col-12 btn btn-red",
                  on: {
                    click: function($event) {
                      return _vm.deactivateSection(_vm.deactivateId)
                    }
                  }
                },
                [_vm._v("Confirm")]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "SectionValidationModal",
        {
          attrs: { isModalVisible: _vm.isSectionValidationModalVisible },
          on: {
            close: function($event) {
              _vm.isSectionValidationModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _vm._v(
                "Section - '" +
                  _vm._s(_vm.validateSectionTitle) +
                  "' already added in this assessment."
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "body" }, slot: "body" }),
          _vm._v(" "),
          _c("div", {
            staticClass: "col-3 override-padding",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loader-img-center" }, [
      _c("i", { staticClass: "fa fa-spinner fa-spin" }),
      _vm._v(" Please wait...\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-10 float-left override-padding" }, [
      _c("h3", { staticClass: "d-inline heading" }, [
        _vm._v("Assessment Sections")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("hr")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-457e32f5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-457e32f5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/assessment_section_list.vue
// module id = null
// module chunks = 